import React from 'react';
import RightArrowIcon from '../../assets/images/righArrowIcon.svg';

interface SearchResultItemProps {
    text: string;
    pageNumber: number;
    pageRef: string;
    bookMarkId: string;
    offset: number;
    onClick: () => void;
    searchWord: string;
}

const SearchResultItem: React.FC<SearchResultItemProps> = ({
    text,
    pageNumber,
    bookMarkId,
    offset,
    onClick,
    searchWord,
}) => {
    const getHighlightedText = (text: string, highlight: string) => {
        if (!highlight.trim()) {
            return text;
        }
        const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
        return parts.map((part, index) =>
            part.toLowerCase() === highlight.toLowerCase() ? (
                <span key={index} className="bg-yellow-300">
                    {part}
                </span>
            ) : (
                part
            )
        );
    };

    return (
        <div
            className="border-b border-gray-200 py-4 hover:cursor-pointer hover:bg-[#EDF1F9] px-2"
            onClick={onClick}
        >
            <div className="flex justify-between items-center">
                <div className="text-gray-700 text-sm truncate">
                    {getHighlightedText(
                        text.length > 50 ? `${text.slice(0, 50)}...` : text,
                        searchWord
                    )}
                </div>
                <div className="flex items-center space-x-2">
                    <span className="text-sm text-gray-500 mr-12">
                        Page {bookMarkId ? bookMarkId : pageNumber - offset}
                    </span>
                    <img src={RightArrowIcon} alt="" />
                </div>
            </div>
        </div>
    );
};

export default SearchResultItem;
